import { ContractTypesEnum } from '@common/enums';

export const ContractTypesTitles = new Map<ContractTypesEnum, string>([
  [ContractTypesEnum.Individual, 'ФЛ'],
  [ContractTypesEnum.LegalEntity, 'ИП'],
  [ContractTypesEnum.CivilLaw, 'ГПХ'],
  [ContractTypesEnum.Entrepreneur, 'ИП'],
  [ContractTypesEnum.Partnership, 'ТОО'],
]);
